import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalService } from '../core/global.service';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var PartnershipService = /** @class */ (function () {
    function PartnershipService(_http, _global) {
        this._http = _http;
        this._global = _global;
    }
    PartnershipService.prototype.find = function () {
        var api = _GlobalNS.api.relationship.relationship;
        return this._http.get("" + api, {});
    };
    PartnershipService.prototype.findTypes = function () {
        var api = _GlobalNS.api.relationship.relationshipType;
        return this._http.get("" + api, {});
    };
    PartnershipService.prototype.findById = function (RelationshipId) {
        var api = _GlobalNS.api.relationship.relationshipById;
        var params = new HttpParams().set('RelationshipId', RelationshipId.toString());
        return this._http.get("" + api, { params: params });
    };
    PartnershipService.prototype.findByPerson = function (PersonId) {
        var api = _GlobalNS.api.relationship.relationshipByPerson;
        var personId = typeof PersonId === 'number' ? PersonId.toString() : '';
        var params = new HttpParams().set('PersonId', personId);
        return this._http.get("" + api, { params: params });
    };
    PartnershipService.ngInjectableDef = i0.defineInjectable({ factory: function PartnershipService_Factory() { return new PartnershipService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: PartnershipService, providedIn: "root" });
    return PartnershipService;
}());
export { PartnershipService };
